"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStackChart = void 0;
var ChartGroupConfig_init_1 = require("@/pages/common/states/ChartGroupConfig.init");
var getColour_1 = require("@/pages/common/transformers/getColour");
exports.getStackChart = function (chartState) {
    var values = Array.from(Array(chartState.yValues.length)).map(function (_, i) { return ({
        color: chartState.yLineColors[i] || getColour_1.getColour(i, chartState.yValues.length),
        label: chartState.yLabels[i],
        series: chartState.yValues[i],
    }); });
    var defaultConfig = JSON.parse(JSON.stringify(ChartGroupConfig_init_1.chartGroupConfigStack));
    var fontSize = 26;
    return __assign(__assign({}, defaultConfig), { charts: [__assign(__assign({}, defaultConfig.charts[0]), { values: values, xAxis: __assign(__assign({}, defaultConfig.charts[0].xAxis), { label: '', series: chartState.xLabels, fontSize: fontSize }), yAxis: __assign(__assign({}, defaultConfig.charts[0].yAxis), { label: chartState.yTitle || '', fontSize: fontSize }) })] });
};
